<template>
  <div
    style="display: flex; flex-direction: column; height: calc(100vh - 180px)"
  >
    <div style="display: flex; flex-wrap: wrap">
      <div class="condition-item">
        <label class="fn-14">
          <span>总数/条: {{ total }}</span>
          <span style="margin-left: 20px">合计金额/分: {{ totalAmount }}</span>
        </label>
      </div>
      <div class="condition-item">
        <label class="fn-14">学生姓名</label>
        <el-input
          v-model="studentName"
          placeholder="请输入学生姓名"
          autocomplete="off"
          style="width: 160px"
          size="small"
        >
        </el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">订单状态</label>
        <el-select
          v-model="payChannel"
          placeholder="请选择订单状态"
          size="small"
          style="width: 90px"
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="微信" :value="91"></el-option>
          <el-option label="支付宝" :value="92"></el-option>
          <el-option label="云闪付" :value="93"></el-option>
          <el-option label="工银e支付" :value="99"></el-option>
        </el-select>
      </div>
      <div class="condition-item">
        <label class="fn-14">支付状态</label>
        <el-select
          v-model="payType"
          placeholder="请选择支付状态"
          size="small"
          style="width: 90px"
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="已支付" :value="1"></el-option>
          <el-option label="已退款" :value="2"></el-option>
        </el-select>
      </div>
      <div class="condition-item">
        <label class="fn-14">订单号</label>
        <el-input
          v-model="corpOrderNo"
          placeholder="请输入订单号"
          autocomplete="off"
          style="width: 160px"
          size="small"
        >
        </el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">支付编号</label>
        <el-input
          v-model="mergenPaymentNo"
          placeholder="请输入并笔支付编号"
          autocomplete="off"
          style="width: 160px"
          size="small"
        ></el-input>
      </div>
      <div class="condition-item">
        <label class="fn-14">日期</label>
        <el-date-picker
          v-model="times"
          align="right"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
        <label class="fn-14" style="padding: 0 10px">-</label>
        <el-date-picker
          v-model="timesEnd"
          align="right"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择结束日期"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
      </div>

      <div class="condition-item">
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click.native="selectData"
          >查询</el-button
        >
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="resetSearch"
          size="small"
          >重置
        </el-button>
      </div>
    </div>
    <div style="margin-bottom: 15px; flex: 1; overflow: hidden">
      <el-table
        :data="orderDetailTableData"
        border
        style="width: 100%"
        height="672"
      >
        <el-table-column
          prop="corpOrderNo"
          label="订单号"
          width="280"
        ></el-table-column>
        <el-table-column
          prop="studentName"
          label="学生姓名"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="payChannel"
          label="支付渠道"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payChannel == 91" size="small">微信</el-tag>
            <el-tag v-if="scope.row.payChannel == 92" size="small"
              >支付宝</el-tag
            >
            <el-tag v-if="scope.row.payChannel == 93" size="small"
              >云闪付</el-tag
            >
            <el-tag v-if="scope.row.payChannel == 99" size="small"
              >工银e支付</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额/分"
          width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payType"
          label="状态"
          width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payType == 1" size="small" type="success"
              >已支付</el-tag
            >
            <el-tag v-if="scope.row.payType == 2" type="danger" size="small"
              >已退款</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="payTime"
          label="支付时间"
          width="160px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="refundTime"
          label="退款时间"
          width="160px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="workDate"
          label="对账时间"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mergenPaymentNo"
          label="并笔支付编号"
          width="240"
        ></el-table-column>
        <el-table-column prop="payId" label="工行流水号"></el-table-column>
      </el-table>
    </div>
    <div style="display: flex; justify-content: right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  queryWechatBatchCheck,
  queryWechatBatchCheckTotal,
} from "../../../api/batchCheck.js";
import { dateFormat } from "../../../utils/date.js";

export default {
  name: "Reconciliation",
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      times: "",
      timesEnd: "",
      orderDetailTableData: [],
      total: 0,
      totalAmount: 0,
      currentPage: 1,
      pageSize: 20,
      payChannel: 0,
      studentName: "",
      payType: 0,
      corpOrderNo: "",
      mergenPaymentNo: "",
    };
  },
  created() {
    var yestday = new Date();
    yestday.setTime(yestday.getTime() - 24 * 60 * 60 * 1000);
    this.times = dateFormat("YYYY-mm-dd", yestday);
    this.timesEnd = dateFormat("YYYY-mm-dd", yestday);
    this.selectData();
  },
  methods: {
    selectData() {
      const datas = {
        stime: this.times,
        etime: this.timesEnd,
        corpOrderNo: this.corpOrderNo,
        mergenPaymentNo: this.mergenPaymentNo,
        studentName: this.studentName,
      };
      if (this.payChannel) {
        datas.payChannel = this.payChannel;
      }
      if (this.payType) {
        datas.payType = this.payType;
      }
      this.tableLoading = true;
      queryWechatBatchCheck(this.currentPage, this.pageSize, datas)
        .then((resp) => {
          this.orderDetailTableData = resp.data.content;
          this.total = resp.data.totalElements;
          this.tableLoading = false;
        })
        .catch((e) => {});
      queryWechatBatchCheckTotal(this.currentPage, this.pageSize, datas)
        .then((resp) => {
          this.totalAmount = resp.data.total || 0;
        })
        .catch((e) => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectData();
    },
    resetSearch() {
      var yestday = new Date();
      yestday.setTime(yestday.getTime() - 24 * 60 * 60 * 1000);
      this.times = dateFormat("YYYY-mm-dd", yestday);
      this.timesEnd = dateFormat("YYYY-mm-dd", yestday);
      this.corpOrderNo = "";
      this.mergenPaymentNo = "";
      this.payChannel = 0;
      this.studentName = "";
      this.payType = 0;
      this.selectData();
    },
  },
};
</script>

<style scope>
.condition-item {
  margin-right: 10px;
}
</style>
